exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v_input_no_lable .el-form-item::before,\r\n.v_input_no_lable .el-form-item__content::before {\r\n  display: none;\n}\n.v_input_no_lable .el-form-item__content {\r\n  line-height: 0;\n}\n.text_style {\r\n  white-space: pre-wrap;\n}\n.el-textarea textarea {\r\n  padding-bottom: 13px;\n}\n.el-textarea .el-input__count {\r\n  margin-right: 5px;\r\n  height: 12px;\r\n  line-height: 12px;\n}\r\n", ""]);

// exports
